import apiUrl from '../../../constants';
import axios from 'axios';
import iptrackerdetails from '../../../iptrackerdetails'

import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
    Validator
} from 'vee-validate'

export default {
    name: 'changepassword',
    components: {
      VueElementLoading
    },
    props: [],
    data() {
        return {
            token: '',
            newpassword: '',
            confirmpassword: '',
            iptrackData:'',
            userid: '',
            errormsg: '',
            successmsg: '',
            isLoading: false,
        }
    },
    computed: {

    },
    mounted() {
      this.token = this.$route.params.token;
      this.checkTokenData();
    },
    methods: {

        checkTokenData(){
          this.isLoading = true;
          this.input = {
            token: this.token
          };

          axios({
            method: "POST",
            url: apiUrl.api_url + "validateresetpasswordtoken",
            data: this.input,
            headers: {
              'Authorization': 'Bearer XYZ'
            }
            }).then((response) => {
              this.isLoading = false;
              if(response.data.code==200){
                this.userid = response.data.userid
              }else{
                this.errormsg = response.data.error;
              }
            }).catch((httpException) => {
              //this.$alertify.success("Logging Failed");
              console.error('exception is:::::::::', httpException)
            })
        },
        changePassword(event) {
            this.isLoading = true;
              this.iptrackData = {
                userid: this.userid,
                email: this.userid
              },
            this.input = ({
                password: this.newpassword
            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'resetpassword/' + this.token,
                'data': this.input
            })
            .then((response) => {
                this.isLoading = false;
                delete this.input.password
                iptrackerdetails.checkUserIP(this.iptrackData,'Forgot Password',this.$route.path,this.input,response.data);

                if (response.data.code == 200) {
                    //this.successmsg = response.data.message;
                    this.$alertify.success(response.data.message);
                    event.target.reset();
                    this.$router.push('/login');
                } else {
                    this.errormsg = response.data.error;
                }
            })
            .catch((httpException) => {
                console.error('exception is:::::::::', httpException)
            })
        },
        resetForm(){
          this.newpassword = '',
          this.confirmpassword = '';
          this.$validator.reset();
          this.errors.clear();
          this.$router.push('/login');
        },
        onSubmit: function(event) {
          this.$validator.validateAll().then((result) => {
            if(result){
              //console.log('form is valid', this.model);
              this.changePassword(event);
            }
          }).catch(() => {
            console.log('errors exist', this.errors)
          });
        }

    }
}

Validator.extend('verifynewpassword', {
    getMessage: field => "The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character and minimum 8 and maximum 16 characters.",
    validate: value => {
        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,16}$)");
        return strongRegex.test(value);
    }
});



// WEBPACK FOOTER //
// ./src/views/components/resetpassword/resetpassword.component.js